import React from "react";
import { useState } from "react";
import {
  Box,
  Button,
  Typography,
  Dialog,
  DialogContent,
  Grid,
  Paper,
  DialogActions,
  Divider,
} from "@mui/material";

const EfficiencyLogsModal = ({ open, handleClose, selectedPicker }) => {
  const [priority, setPriority] = useState("-");
  const [picker, setPicker] = useState("-");

  if (!selectedPicker) return null;

  let formattedDate = "";
  let formattedTime = "";

  if (selectedPicker.orderDate) {
    const dateParts = selectedPicker.orderDate.split(" ");
    if (dateParts.length >= 1) {
      const dateComponents = dateParts[0].split("/");
      if (dateComponents.length === 3) {
        formattedDate = `${dateComponents[1]}/${dateComponents[0]}/${dateComponents[2]}`;
      } else {
        formattedDate = dateParts[0];
      }
    }

    if (dateParts.length >= 2) {
      formattedTime = dateParts[1];
    }
  }

  const handlePriorityChange = (event) => {
    setPriority(event.target.value);
  };

  const handlePickerChange = (event) => {
    setPicker(event.target.value);
  };

  const auditLogs = [
    { time: "10/02/2025 9:30 AM", log: "Order Picked" },
    {
      time: "10/02/2025 9:35 AM",
      log: "Scanned: A B.COVER RR CZ-3 15-18 No Sen from Bay: M6-Bay6",
    },
    {
      time: "10/02/2025 9:45 AM",
      log: "Scanned: BACK LIGHT TAIL from Bay: M7-Bay1",
    },
    {
      time: "10/02/2025 9:45 AM",
      log: "Scanned: BACK LIGHT TAIL from Bay: M7-Bay1",
    },
    {
      time: "10/02/2025 9:46 AM",
      log: "Scanned: BACK LIGHT TAIL from Bay: M7-Bay1",
    },
    { time: "10/02/2025 9:47 AM", log: "Verified the Picked Order" },
    { time: "10/02/2025 10:00 AM", log: "Scanned the Bay Location" },
    { time: "10/02/2025 10:00 AM", log: "Order Marked Successful" },
  ];

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          maxWidth: 1000,
        },
      }}
    >
      <DialogContent sx={{ p: 4, pb: 2 }}>
        <Typography
          variant="h6"
          sx={{
            fontFamily: "Lexend",
            fontSize: "20px",
            mb: 3,
            fontWeight: 500,
            color: "383E49",
          }}
        >
          Pickup Audit Trail
        </Typography>

        <Paper
          elevation={0}
          sx={{ p: 2, mb: 1, backgroundColor: "action.hover" }}
        >
          <Grid container spacing={2}>
            <Grid item xs={3}>
              <Typography variant="subtitle2" fontWeight="bold">
                Time
              </Typography>
            </Grid>
            <Grid item xs={9}>
              <Typography variant="subtitle2" fontWeight="bold">
                Log
              </Typography>
            </Grid>
          </Grid>
        </Paper>

        <Box sx={{ maxHeight: "450px", overflow: "auto" }}>
          {auditLogs.map((entry, index) => (
            <Box key={index} sx={{ mb: 2 }}>
              <Grid container spacing={2}>
                <Grid item xs={3}>
                  <Typography
                    variant="body2"
                    sx={{ fontSize: "14px", fontWeight: 500, color: "#48505E" }}
                  >
                    {entry.time}
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <Typography
                    variant="body2"
                    sx={{ fontSize: "14px", fontWeight: 500, color: "#000000" }}
                  >
                    {entry.log}
                  </Typography>
                </Grid>
              </Grid>
              {index < auditLogs.length - 1 && <Divider sx={{ my: 2 }} />}
            </Box>
          ))}
        </Box>

        <Box sx={{ mt: 2 }}>
          <Divider />
          <Typography variant="body2" sx={{ mt: 2, textAlign: "left" }}>
            <strong>Total Duration: 30 mins</strong>
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 3 }}>
        <Button
          variant="outlined"
          onClick={handleClose}
          sx={{ mr: 1, borderRadius: 1 }}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EfficiencyLogsModal;
